/**
 *
 * @param {number} start
 * @param {number} end
 */
function range(start, end) {
  const result = []
  for (let i = start; i < end; i++) {
    result.push(i)
  }
  return result
}

/**
 * ปิดใช้งานช่วงเวลาในการเลือกคิวงานซ่อม
 */
export const disabledDateTime = () => {
  return {
    disabledHours: () => range(0, 24).splice(18, 6),
    disabledMinutes: () => range(46, 60),
    disabledSeconds: () => range(1, 60),
  }
}
